var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBannerOverlaySolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 538.274"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1046",
    d: "M0 538.274V0h1920v226.529z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "5aed57df4a98e25d1d52e29c691b2586.svg";
export { SvgBannerOverlaySolid as ReactComponent };